import React from "react";
import SubscriptionPlans from "../SubscriptionPlans/SubscriptionPlans";
import "./PricingPage.css";

const PricingPage = () => {
  return (
    <div className="pricing-page" style={{ backgroundColor: '#eff2ff', minHeight: '100vh' }}>    
      <div className="pricing-container">
        <SubscriptionPlans readOnly={true} />
      </div>
    </div>
  );
};

export default PricingPage; 